export default __webpack_public_path__ + "static/media/Aaron_GirthyGarth.20505230.png";